<template>
	<div class="lineComment">
		<div class="head">
			<div class="name">{{ item.created_by }}</div>
			<div class="date">{{ date }}</div>
			<div class="time">{{ time }}</div>
		</div>
		<div class="main">
			<div class="text">{{ item.note }}</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment-timezone';

export default {
	name: "LineComment",
	props: {
		item: Object,
	},
	data() {
		return {
			date: null,
			time: null,
		};
	},
	mounted() {
		if (this.item) {
			const { updated_at } = this.item;

			// Извлекаем дату и время без преобразования часового пояса
			this.date = moment(updated_at).format('YYYY-MM-DD');
			this.time = moment(updated_at).format('HH:mm');
		}
	},

};
</script>

<style scoped lang="scss">
.lineComment {
	.head {
		display: flex;
		gap: 6px;
		background: rgb(7 126 30 / 12%);
		padding: 6px 12px;
		.name {
			flex: 2 0;
			font-weight: bold;
			color: #a3a3a3;
		}
		.date {
			display: flex;
			align-items: center;
			color: #1dab39;
			font-size: 12px;
		}
		.time {
			display: flex;
			align-items: center;
			font-size: 12px;
			color: rgba(7, 126, 30, 0.75);
		}
	}

	.main {
		background: rgb(255 255 255 / 4%);
		padding: 6px 12px;
		.text {}
	}
}
</style>
